import { ContractStore } from "../models/contractModel";

export default ContractStore.create({
    contracts: {},
    loaded: false,
});


// WEBPACK FOOTER //
// ./src/stores/ContractStore.js